import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { SaveMission } from '../../../store/actions/mission.actions';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { CustomerStorageService } from '../../../../account/services/customer-storage.service';
import { environment } from '../../../../../../environments/environment';
import { LandLineListInterface } from '../../../../landlines/models/land-line-list.interface';
import { SaveLandlineMission } from '../../../store/actions/landline-mission.actions';
import { TechnicalAssistanceService } from '../../../services/technical-assistance.service';

@Component({
  selector: 'app-technical-assistance',
  templateUrl: './technical-assistance.component.html',
  styleUrls: ['./technical-assistance.component.css'],
  standalone: false
})
export class TechnicalAssistanceComponent implements OnInit {

  @Input()
  line: LineInterface|null;

  @Input()
  landLine: LandLineListInterface|null;

  @Input()
  procedureCode: string;

  assistanceUrl = environment.data.assistanceUrl;
  customer: CustomerInterface;
  environment = environment;

  constructor(
      private store: Store<any>,
      private customerStorage: CustomerStorageService,
      private technicalAssistanceService: TechnicalAssistanceService
  ) {
  }

  ngOnInit() {
    this.customer = this.customerStorage.getCustomer();
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  goToSupervisionPlatform() {
    this.technicalAssistanceService.get('supervision').subscribe(
        response => {
            if (response.groupId && response.hashGroupId) {
                window.open(
                    'https://supervision.coriolis-cs.net/index.php?name=' + response.groupId + '&password=' + response.hashGroupId + '&autologin=1&enter=Sign+in',
                    '_blank'
                );
            }
        }
    );
  }

  goToIncidentPlatform() {
    this.technicalAssistanceService.get('gestion').subscribe(
        response => {
            if (response.groupId && response.hashGroupId) {
                window.open(
                    'https://gestion-incidents.coriolis-cs.net/NoAuth/Login.html?user=' + response.groupId + '&pass=' + response.hashGroupId,
                    '_blank'
                );
            }
        }
    );
  }

  confirmation() {
    if (this.landLine) {
      this.store.dispatch(new SaveLandlineMission(
          {
            landline: this.landLine.phoneNumber
          },
          this.procedureCode)
      );
    } else {
      this.store.dispatch(new SaveMission(
          {
            phoneNumber: this.line.phoneNumber
          },
          this.procedureCode)
      );
    }
  }
}
